function styleTagTransform(styleAsString, htmlStyleElement) {
  //We create a CSSStylesheet object here and add it to the DOM.
  //We do this so it is sharable between the normal DOM and shadow-dom
  const stylesheetObject = new CSSStyleSheet();
  stylesheetObject.neonStyleSheet = true;
  stylesheetObject.replaceSync(styleAsString);

  //For some reason Safari loses our added property neonStyleSheet.... sometimes.
  //We still need to mark the stylesheet as a Neon stylesheet so we add a fake
  //selector to the stylesheet at the beginning that shadow-dom-utils can check for.
  stylesheetObject.insertRule('neon-stylesheet-fake-selector{ --neon-fake-property-for-safari-fallback: true; }', 0);
  document.adoptedStyleSheets.push(stylesheetObject);

  //Firing and event here so the listener can add it to the shadow-dom
  //See applyNeonStylesToShadowDom function in show-dom-utils.tsx.
  document.dispatchEvent(new CustomEvent('neonAddStyleSheet', { detail: {stylesheet: stylesheetObject}}));
}


export default styleTagTransform;